import type { TSignupVerifyErrorCode, TSignupVerifyErrorField } from "@/api/launcherApp/signup/schema"

const errorCodeToTranslationKey: Record<string, string> = {
  "companyName.blank": "companyName.blank",
  "companyName.nullable": "companyName.nullable",
  "companyName.size.toobig": "companyName.size.toobig",
  "companyName.matches.invalid": "companyName.matches.invalid",
  "email.blank": "email.blank",
  "email.nullable": "email.nullable",
  "email.size.toobig": "email.size.toobig",
  "email.email.invalid": "email.email.invalid",
  "email.validator.invalid": "email.validator.invalid",
  "email.signup.index.step_one.blacklisted.ringio": "email.signup.index.step_one.blacklisted.ringio",
  "email.accountCreationCommand.email.zerobounce.validation.invalid": "email.accountCreationCommand.email.zerobounce.validation.invalid",
  "email.accountCreationCommand.email.zerobounce.validation.temporaryUnavailable": "email.accountCreationCommand.email.zerobounce.validation.temporaryUnavailable",
  "firstName.blank": "firstName.blank",
  "firstName.nullable": "firstName.nullable",
  "firstName.size.toobig": "firstName.size.toobig",
  "firstName.matches.invalid": "firstName.matches.invalid",
  "lastName.blank": "lastName.blank",
  "lastName.nullable": "lastName.nullable",
  "lastName.size.toobig": "lastName.size.toobig",
  "lastName.matches.invalid": "lastName.matches.invalid",
  "passwd.validator.invalid": "passwd.validator.invalid",
  "passwd.blank": "passwd.blank",
  "passwd.nullable": "passwd.nullable",
  "phoneNumber.validator.invalid": "phoneNumber.validator.invalid",
  "phoneNumber.blank": "phoneNumber.blank",
  "phoneNumber.nullable": "phoneNumber.nullable",
}

const apiFieldToFormField: Record<TSignupVerifyErrorField, string> = {
  email: "email",
  firstName: "firstName",
  lastName: "lastName",
  phoneNumber: "phone",
  companyName: "company",
  passwd: "password",
  smsOptIn: "smsAccepted",
  emailMarketingOptIn: "promotionalEmails",
  trialType: "trialType",
}

export function mapApiErrorsToFormErrors(errors: Array<{ code: TSignupVerifyErrorCode; field: TSignupVerifyErrorField }>, t: (key: string) => string) {
  return errors.reduce(
    (acc, error) => {
      const formField = apiFieldToFormField[error.field]
      const translationKey = errorCodeToTranslationKey[`${error.field}.${error.code}`]
      if (formField && translationKey) {
        // @ts-expect-error
        acc[formField] = t(translationKey, { email: error.rejectedValue })
      }
      return acc
    },
    {} as Record<string, string>
  )
}
